//创建一个store，用于存储布局相关信息，目前只存储是否展示siderbar
import { create } from 'zustand'

interface State {
  showSidebar: boolean
  setShowSidebar: (showSidebar: boolean) => void
}

export const useLayoutStore = create<State>((set) => ({
  showSidebar: true,
  setShowSidebar: (showSidebar) => set({ showSidebar }),
}))
